import { createVuetify } from 'vuetify'
import 'vuetify/styles'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi'

export default createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        dark: false,
        colors: {
          primary: '#2C5F7C', // Logo koyu mavi
          secondary: '#A8D5BA', // Logo açık yeşil
          accent: '#7FB069', // Daha koyu yeşil ton
          error: '#E74C3C',
          info: '#3498DB',
          success: '#27AE60',
          warning: '#F39C12',
          background: '#F8FFFE',
          surface: '#FFFFFF',
        }
      },
      dark: {
        dark: true,
        colors: {
          primary: '#4A8DB8', // Açık mavi ton
          secondary: '#A8D5BA', // Logo yeşili korundu
          accent: '#95C785', // Açık yeşil ton
          error: '#E74C3C',
          info: '#5DADE2',
          success: '#58D68D',
          warning: '#F7DC6F',
          background: '#1A1A1A',
          surface: '#2D2D2D',
        }
      }
    }
  },
  defaults: {
    VBtn: {
      style: 'text-transform: none;'
    },
    VCard: {
      elevation: 2
    }
  }
})